import Image from 'app/Components/Shared/Image/image';
import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { getImageProps } from 'app/utilities/ImageProps';
import { createLead, reportDWH, initBlock } from './SliderLeadSlice';
import { gtag4 } from '../../../utilities/analytics/tracking';
import { buildUrlAndOpenSameWindow } from '../../../utilities/StringHelpers/StringHelpers';


const SliderLead = (props) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);
  const { iContent, context } = props; //from EPI
  const [isClickLead,setIsClickLead] = useState(false);
  const [isImageMoved, setIsImageMoved] = useState(false);
  const [modeSendLead,setModeSendLead] = useState();
  const imageRef = useRef(null);
  const sliderRef = useRef(null);

  const icon = getImageProps(iContent.icon, context);
  const textUpper = iContent.textUpper.value;
  const textLower = iContent.textLower.value;
  const textSuccess= iContent.textSuccess.value;
  const textFail = iContent.textFail.value;
  const textPressAgain= iContent.textPressAgain.value;
  const linkUrl = iContent.linkUrl.value;
  const isLinkButton = iContent.isLinkButton.value;

  const adjustImagePosition = (moveLeft = false) => {
    if (isMobile) {
      if (imageRef.current && sliderRef.current) {
        const imageWidth = moveLeft ? imageRef.current.offsetWidth - 110 : imageRef.current.offsetWidth;
        const sliderWidth = sliderRef.current.offsetWidth;
        const padding = 4;
        const moveAmount = moveLeft ? 0 - sliderWidth - imageWidth - padding : sliderWidth - imageWidth - padding;
        if (moveAmount < 0) {
          imageRef.current.classList.add('image-transition');
          imageRef.current.style.transform = `translateX(${moveAmount}px)`;
        } else {
          imageRef.current.style.transform = 'translateX(0)';
        }
      }
    }
  };

  useEffect(() => {
    props.initBlock({ sliderLeadBlock: props.iContent });
    gtag4({ event: '', action: '' });

    if (isMobile) {
      adjustImagePosition();
    }
  }, [props.iContent, isMobile]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (isMobile) {
        adjustImagePosition(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMobile]);

  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  const pageFormLinkEpi=  async (linkUrl) => {
    if(isMobile) {
      setIsImageMoved(true);
      adjustImagePosition(true);
      await delay(1300);
      buildUrlAndOpenSameWindow(linkUrl);
      // Return to starting position
      await delay(1000);
      setIsClickLead(false);
      setIsImageMoved(false);
      adjustImagePosition(false);
    }
    else{
      buildUrlAndOpenSameWindow(linkUrl);
    };
  };

  const sendingRepeatRequest = async () => {
    if (isMobile) {
      setIsImageMoved(true);
      adjustImagePosition(true);
      await delay(1300);
      setModeSendLead('limitExceeded');
      setIsClickLead(true);
    } else {
      setModeSendLead('limitExceeded');
      setIsClickLead(true);
    }
    await delay(3500);
    setIsClickLead(false);
    setIsImageMoved(false);
  };

  const sendLead = async (leadClickCount) => {
    let createLead = await props.createLead();
    if (isMobile) {
      setIsImageMoved(true);
      adjustImagePosition(true);
    };
    await delay(1300);
    setModeSendLead(createLead?.payload?.Body?.isSuccess ? 'success' : 'fail');
    setIsClickLead(true);
    await delay(3000);
    setIsClickLead(false);
    setIsImageMoved(false);
    adjustImagePosition(false);
    sessionStorage.setItem('leadClickCount', Number(leadClickCount) + 0);
  };

  const clickLead = async () => {
    try {
        // Go to the page according to the link from EPI
        if (isLinkButton === true && linkUrl != null) {
          pageFormLinkEpi(linkUrl);
          return;
        };
      //Treatment for re-sending the halide
        const leadClickCount = sessionStorage.getItem('leadClickCount') || 0;
        if (leadClickCount > 0) sendingRepeatRequest()
        else sendLead(leadClickCount);
    } catch (error) {
      setModeSendLead('fail');
      setIsImageMoved(false);
      setIsClickLead(true);
    }
    props.reportDWH({ actionType: `MyZone ${props.worldType} Lobby`, status: 'Ongoing', messageText: 'Slider Button Clicked' });
  };

  const messageLead = (modeSendLead) => {
    switch (modeSendLead) {
      case 'success':
        return <div dangerouslySetInnerHTML={{ __html: textSuccess }}></div>;
      case 'fail':
        return <div dangerouslySetInnerHTML={{ __html: textFail }}></div>;
      case 'limitExceeded':
        return <div dangerouslySetInnerHTML={{ __html: textPressAgain }}></div>;
      default:
        return null;
    };
  };

  return (
    <div className='container-general'>
      {!isClickLead &&
      <div className='container-lead' onClick={clickLead} ref={sliderRef}>
        <div className='container-img'>
          <Image src={icon.src} alt={icon.alt} className={isImageMoved ? 'move-left' : ''} ref={imageRef} style={{ transform: 'translateX(0)' }} />
        </div>
        <div className={`wrapper-text ${isImageMoved ? 'change-text-bright' : ''}`}>
          <div className='text' dangerouslySetInnerHTML={{ __html: textUpper }}></div>
          <div className='text' dangerouslySetInnerHTML={{ __html: textLower }}></div>
        </div>
        <div className='wrapper-arrow'>
          <div className='desktop-arrows'>
            <div className='arrow'></div>
          </div>
          <div className='mobile-arrows'>
              {Array.from({ length: 1 }).map((_, index) => (
                <div key={index} className={`arrow ${isImageMoved ? 'change-arrow-bright' : ''}`}></div>
              ))}
          </div>
        </div>
      </div>
      }
      {isClickLead &&<div className='mes-lead'>{messageLead(modeSendLead)}</div>}
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    worldType: state.selfcarePage.epiData.worldType,

  };
};

const mapDispatchToProps = {
  createLead,
  reportDWH,
  initBlock,
};

export default connect(mapStateToProps, mapDispatchToProps)(SliderLead);

